export const SET_RESULTS = 'SET_RESULTS';
export const UPDATE_SEARCH_TERM = 'UPDATE_SEARCH_TERM';
export const SET_SEARCH_TERM_ERRORS = 'SET_SEARCH_TERM_ERRORS';
export const SET_SEARCH_LOADING = 'SET_SEARCH_LOADING';
export const CLEAR_RESULTS = 'CLEAR_RESULTS';
export const SET_MORE_RESULTS = 'SET_MORE_RESULTS';

export const SAGA_INIT_SEARCH = 'SAGA_INIT_SEARCH';
export const SAGA_DOCUMENT_SEARCH_REQUESTED = 'SAGA_DOCUMENT_SEARCH_REQUESTED';
export const SAGA_SET_SEARCH_TERM = 'SAGA_SET_SEARCH_TERM';
export const SAGA_NEXT_SEARCH_PAGE = 'SAGA_NEXT_SEARCH_PAGE';


export class Saga {

  static setSearchTerm(searchTerm, pageNumber) {
    return {type: SAGA_SET_SEARCH_TERM, searchTerm, pageNumber}
  }

  static initSearch() {
    return {type: SAGA_INIT_SEARCH}
  }

  static loadNextSearchPage(pageNo) {
    return {
      type: SAGA_NEXT_SEARCH_PAGE,
      pageNo
    }
  }

  static set
}

export class Generator {

  static setLoadingSearch(loading) {
    return {
      type: SET_SEARCH_LOADING,
      searchLoading: loading
    }
  }

  static clearResults() {
    return {
      type: CLEAR_RESULTS
    }
  }

  static setResults(page) {
    return {
      type: SET_RESULTS,
      searchLoading: false,
      page
    }
  }

  static setMoreResults(page) {
    return {
      type: SET_MORE_RESULTS,
      page
    }
  }

  static setSearch(searchTerm, pageNumber = 0) {
    return {
      type: UPDATE_SEARCH_TERM,
      searchTerm,
      pageNumber
    }
  }

  static setSearchTermErrors(validationError) {
    return {
      type: SET_SEARCH_TERM_ERRORS,
      validationError
    }
  }
}

